import { render, staticRenderFns } from "./Tratamientos.vue?vue&type=template&id=b4e77878&scoped=true"
import script from "./Tratamientos.vue?vue&type=script&lang=js"
export * from "./Tratamientos.vue?vue&type=script&lang=js"
import style0 from "./Tratamientos.vue?vue&type=style&index=0&id=b4e77878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e77878",
  null
  
)

export default component.exports